import React from "react"
import { useDispatch } from "react-redux"
import Stack from "@mui/material/Stack"
import { handlePremiumOnboarding } from "utils/componentsUtils"
import PremiumLogo from "components/atoms/_icons/PremiumLogo"
import WishamProButton from "components/atoms/WishamProButton"

type ProLimitBannerContentProps = {
  message: string | React.ReactNode;
  feature?: string;
}

export default function ProLimitBannerContent(props: ProLimitBannerContentProps) {
  const { message, feature = "" } = props

  const dispatch = useDispatch()

  function handleUpgradeToProButtonClicked(event: React.MouseEvent<HTMLButtonElement>) {
    handlePremiumOnboarding(event, feature, dispatch)
  }

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" padding="4px 0">
      <Stack direction="row" justifyContent="flex-start" alignItems="center" gap="6px">
        <PremiumLogo width={32} height={32}/>
        <p>{message}</p>
      </Stack>
      <WishamProButton onClick={handleUpgradeToProButtonClicked}/>
    </Stack>
  )
}
